/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".input-group[_ngcontent-%COMP%]{display:flex;flex-direction:row}.mat-form-field[_ngcontent-%COMP%], button[_ngcontent-%COMP%], mat-slide-toggle[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{margin:.5rem 1rem}ca-photo-picker[_ngcontent-%COMP%]{margin-top:8px;margin-bottom:8px;margin-left:16px;display:block;position:relative;width:100%;height:200px}.hidden-field[_ngcontent-%COMP%]{display:none}agm-map[_ngcontent-%COMP%]{height:300px}.map-holder[_ngcontent-%COMP%]{height:300px;border-radius:8px;overflow:hidden;width:100%}"];
export { styles as styles };
